<template>

  <b-spinner
      variant="success"
      label="Spinning"
      style="
            width: 3rem;
            height: 3rem;
            margin: 20px auto;
          "
      v-if="!team"
  ></b-spinner>
  <div v-else>
    <div>
      <div
          style="
          height: 45px;
          line-height: 45px;
          background: #2c2d31;
          color: #e6e6e6;
        "
      >
        <span style="margin-left: 10px; font-size: 12px">
          {{ $t("LanguageEn.teamInformation") }}
        </span>
      </div>
      <div>
        <div class="container">
          <div
              class="row"
              style="background: #212225; min-height: 140px; color: #e6e6e6"
          >
            <div class="col" style="line-height: 140px">
              <img
                  style="width: 90px; margin-left: 20px; margin-right: 10px"
                  :src="teamLogo + id"
              />
              <span style="color: lightgrey">
                {{ team.name | transliterate(languageCode) }}</span
              >
              <img
                  v-if="favTeams.some((fav) => fav.id === id)"
                  v-on:click="removeFavorite({ value: id, type: 'team' })"
                  :src="favImage1"
                  style="
                  width: 15px;
                  cursor: pointer;
                  margin-left: 10px;
                  margin-right: 10px;
                  margin-bottom: 5px;
                "
                  alt=""
              />
              <img
                  v-else
                  v-on:click="addToFavorites({ value: id, type: 'team' })"
                  :src="favImage"
                  style="
                  width: 15px;
                  cursor: pointer;
                  margin-left: 10px;
                  margin-right: 10px;
                  margin-bottom: 5px;
                "
                  alt=""
              />
            </div>
            <div class="col-md-3" style="padding-top: 35px; font-size: 14px">
              <p style="" v-if="ranking">
                <router-link
                    id="routerLink"
                    style="
                    padding: 0 !important;
                    text-decoration: none !important;
                  "
                    :to="{ name: 'Ranks', params: { type: ranking.ranking } }"
                >
                  {{
                    ranking.ranking.toUpperCase() | transliterate(languageCode)
                  }}
                  {{ $t("LanguageEn.ranking") }}:
                  {{ ranking.position | transliterate(languageCode) }}
                  <img
                      v-if="ranking.positionStatus === 'up'"
                      src="@/assets/up.png"
                      style="width: 15px; margin-bottom: 5px; margin-left: 2px"
                      alt=""
                  /><img
                    v-else-if="ranking.positionStatus === 'down'"
                    src="@/assets/down.png"
                    style="width: 15px; margin-bottom: 5px; margin-left: 2px"
                    alt=""
                /><img
                    v-else-if="ranking.positionStatus === 'equal'"
                    src="@/assets/dash.png"
                    style="width: 15px; margin-bottom: 5px; margin-left: 2px"
                    alt=""
                /><span v-else></span><br/>
                </router-link>
                {{ $t("LanguageEn.points") }}:
                {{ ranking.points | transliterate(languageCode) }} <br/>
                <span v-if="ranking.ranking == 'uefa'">
                  {{ $t("LanguageEn.Coeffiecient") }}:
                  {{ ranking.coeffiecient | transliterate(languageCode) }}</span
                ><br/>
                <!-- Rotation:  {{ranking5}} -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div>
      <b-tabs
          v-model="tabIndex"
          class="Some"
          style="border-radius: 0; color: white; background: #2c2d31"
          nav-class="ks1"
          active-nav-item-class="ks"
          active-tab-class=""
          content-class=""
      >
        <b-tab style="border-radius: 0">
          <template v-slot:title>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
                v-if="tabIndex == 0"
            >
              {{ $t("LanguageEn.Result") }}
            </p>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
                v-else
            >
              {{ $t("LanguageEn.Result") }}
            </p>
          </template>
          <div style="height: 15px; background: #141416"></div>
          <div v-for="(game, count) in gamesHistory" :key="count" style="">

            <MobileMatchListItem :game="game" v-if="isMobile || isTablet"/>
            <MatchListItem :game="game" v-else/>
          </div>
          <div
              style="
              padding-top: 10px;
              padding-bottom: 10px;
              text-align: center;
              background: #141416;
            "
          >
            <b-btn
                variant="success"
                style="width: 200px; border-radius: 0; background: #1c5e20"
                v-on:click="pageCount++, addGames()"
            >{{ $t("LanguageEn.moreGames") }}
            </b-btn
            >
          </div>
        </b-tab>
        <b-tab style="border-radius: 0">
          <template v-slot:title>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
                v-if="tabIndex == 1"
            >
              {{ $t("LanguageEn.txtStatistics") }}
            </p>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
                v-else
            >
              {{ $t("LanguageEn.txtStatistics") }}
            </p>
          </template>

          <div class="" style="text-align: left; background: #141416">
            <div>
              <div style="color: whitesmoke">
                <div class="container">
                  <div class="row">
                    <b-form-select
                        v-model="year"
                        class="mb-3 col mr-1"
                        @change="filter(year)"
                        style="
                        margin-top: 15px;
                        background: #212225;
                        border: none;
                        border-radius: 2px;
                        color: #e6e6e6;
                      "
                    >
                      <b-form-select-option
                          v-for="i in ex"
                          :key="i.id"
                          :value="i.id"
                      >{{ i.y | transliterate(languageCode) }}
                        {{
                          i.name | transliterate(languageCode)
                        }}
                      </b-form-select-option
                      >
                    </b-form-select>

                    <b-form-select
                        v-model="chstat"
                        class="mb-3 col ml-1"
                        style="
                        margin-top: 15px;
                        background: #212225;
                        border: none;
                        border-radius: 2px;
                        color: #e6e6e6;
                      "
                    >
                      <b-form-select-option :value="1">{{
                          $t("LanguageEn.mStatistics")
                        }}
                      </b-form-select-option>
                      <b-form-select-option :value="2">{{
                          $t("LanguageEn.sDetails")
                        }}
                      </b-form-select-option>
                      <b-form-select-option :value="3">{{
                          $t("LanguageEn.sGoal")
                        }}
                      </b-form-select-option>
                      <b-form-select-option :value="4">{{
                          $t("LanguageEn.STiming")
                        }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                </div>

                <div v-if="chstat == 1">
                  <li
                      class="row MobileHide"
                      style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col-6"> {{ $t("LanguageEn.details") }} </span>
                    <span class="col">{{ $t("LanguageEn.result") }} </span>
                  </li>
                  <li
                      class="row MobileShow"
                      style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col"> {{ $t("LanguageEn.details") }} </span>
                    <span class="col-2 mr-2" style="text-align: right"
                    >{{ $t("LanguageEn.result") }}
                    </span>
                  </li>
                  <div v-for="(s, ix) in testarr" :key="ix">
                    <div v-for="(item, i) in s" :key="i">
                      <!-- <p v-if="item.season.id == bst">{{item.dataKey}} - {{item.dataValue}}</p> -->
                      <li
                          class="row MobileHide"
                          v-if="item.season.id == year"
                          style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col-6" style="color: grey">
                          {{ item.dataKey | transliterate(languageCode) }}
                        </span>
                        <span class="col"
                        >{{
                            item.dataValue | transliterate(languageCode)
                          }}
                        </span>
                      </li>
                      <li
                          class="row MobileShow"
                          v-if="item.season.id == year"
                          style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col" style="color: grey">
                          {{ item.dataKey | transliterate(languageCode) }}
                        </span>
                        <span class="col-2" style="text-align: right"
                        >{{
                            item.dataValue | transliterate(languageCode)
                          }}
                        </span>
                      </li>
                    </div>
                  </div>
                </div>

                <div v-if="chstat == 2">
                  <li
                      class="row MobileHide"
                      style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col-6" style="font-size: 16px"
                    >{{ $t("LanguageEn.category") }}
                    </span>
                    <span class="col">{{ $t("LanguageEn.home") }} </span
                    ><span class="col">{{ $t("LanguageEn.away") }} </span
                  ><span class="col">{{ $t("LanguageEn.total") }} </span>
                  </li>
                  <li
                      class="row MobileShow"
                      style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span class="col"> {{ $t("LanguageEn.category") }} </span>
                    <span class="col-2 mr-2" style="text-align: right"
                    >{{ $t("LanguageEn.total") }}
                    </span>
                  </li>
                  <div v-for="(s, inx) in testarr2" :key="inx">
                    <div v-for="(item, ind) in s" :key="ind">
                      <li
                          class="row MobileHide"
                          v-if="item.season.id == year"
                          style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col-6" style="color: grey">
                          {{
                            item.category.replace(/_/g, " ")
                                | transliterate(languageCode)
                          }}
                        </span>
                        <span class="col"
                        >{{
                            item.home | transliterate(languageCode)
                          }} </span
                        ><span class="col"
                      >{{
                          item.away | transliterate(languageCode)
                        }} </span
                      ><span class="col"
                      >{{ item.total | transliterate(languageCode) }}
                        </span>
                      </li>
                      <li
                          class="row MobileShow"
                          v-if="item.season.id == year"
                          style="
                          margin-left: 10px;
                          margin-right: 10px;
                          height: 34px;
                          line-height: 34px;
                          border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                        "
                      >
                        <span class="col" style="color: grey">
                          {{
                            item.category.replace(/_/g, " ")
                                | transliterate(languageCode)
                          }}
                        </span>
                        <span class="col-2" style="text-align: right"
                        >{{ item.total | transliterate(languageCode) }}
                        </span>
                      </li>
                    </div>
                  </div>
                </div>

                <div v-if="chstat == 3">
                  <li
                      class="row"
                      style="
                      color: #e6e6e6;
                      margin-left: 10px;
                      margin-right: 10px;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span
                        v-bind:class="{ gcl: haw == 'home' }"
                        class="col-3"
                        @click="haw = 'home'"
                        style="cursor: pointer"
                    >{{ $t("LanguageEn.home") }}
                    </span>
                    <span
                        style="cursor: pointer"
                        v-bind:class="{ gcl: haw == 'away' }"
                        class="col-2 ml-0 pl-0"
                        @click="haw = 'away'"
                    >{{ $t("LanguageEn.away") }}
                    </span>
                  </li>
                  <div v-for="(s, ik) in testarr3" :key="ik">
                    <div v-for="(item, sik) in s" :key="sik">
                      <div
                          class="container"
                          v-if="item.venue == haw && item.direction == 'under'"
                      >
                        <p
                            class="row"
                            style="
                            text-align: center;
                            font-size: 14px;
                            margin-top: 10px;
                          "
                        >
                          <span class="col"
                          >{{
                              item.value | transliterate(languageCode)
                            }}%</span
                          >
                          <span class="col"
                          >{{
                              item.minutes.replace(/_/g, ".")
                                  | transliterate(languageCode)
                            }}
                            Goals
                          </span>
                          <span class="col"
                          >{{
                              (100 - item.value).toFixed(2)
                                  | transliterate(languageCode)
                            }}%</span
                          >
                        </p>
                        <b-progress
                            class=""
                            :max="200"
                            style="
                            border-radius: 0;
                            height: 11px;
                            background: #2c2d31;
                          "
                        >
                          <b-progress-bar
                              style="font-weight: 800;
                               background: #2c2d31"
                              :value="100 - item.value"
                              variant=""
                          ></b-progress-bar>
                          <b-progress-bar
                              style="
                              font-weight: 800;
                              background: #5c5c5e;
                              border-right: 1px solid #2c2d31;
                            "
                              v-bind:class="{ ybg: item.value > 50 }"
                              :value="item.value"
                              variant=""
                          ></b-progress-bar>
                          <b-progress-bar
                              style="
                              font-weight: 800;
                              background: #5c5c5e;
                              border-left: 1px solid #2c2d31;
                            "
                              v-bind:class="{ ybg: 100 - item.value > 50 }"
                              :value="100 - item.value"
                          ></b-progress-bar>
                          <b-progress-bar
                              style="font-weight: 800;
                               background: #2c2d31"
                              :value="item.value"
                              variant=""
                          ></b-progress-bar>
                        </b-progress>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="chstat == 4">
                  <!-- <div v-for="s in testarr4" :key="s.id">
              <div v-for="item in s" :key="item.id">
              
              </div>
          </div> -->
                  <li
                      class="row"
                      style="
                      color: #e6e6e6;
                      margin-bottom: 10px;
                      margin-left: 0;
                      margin-right: 0;
                      height: 34px;
                      line-height: 34px;
                      background: #212225;
                    "
                  >
                    <span
                        v-bind:class="{ gcl: sc == 1 }"
                        class="col-3"
                        @click="sc = 1"
                        style="cursor: pointer"
                    >{{ $t("LanguageEn.scored") }}
                    </span>
                    <span
                        style="cursor: pointer"
                        v-bind:class="{ gcl: sc == 2 }"
                        class="col-2 ml-0 pl-0"
                        @click="sc = 2"
                    >{{ $t("LanguageEn.conceded") }}
                    </span>
                  </li>

                  <area-chart
                      v-if="sc == 1"
                      xtitle="Minutes"
                      ytitle="Goals"
                      :colors="['rgba(67, 160, 71, 0.5)']"
                      :data="{
                      '0-15': testarr5[0].count,
                      '15-30': testarr5[1].count,
                      '30-45': testarr5[2].count,
                      '45-60': testarr5[3].count,
                      '60-75': testarr5[4].count,
                      '75-90': testarr5[5].count,
                    }"
                  >
                  </area-chart>
                  <area-chart
                      v-else
                      xtitle="Minutes"
                      ytitle="Goals"
                      :colors="['rgba(208, 73, 89, 0.5)']"
                      :data="{
                      '0-15': testarr6[0].count,
                      '15-30': testarr6[1].count,
                      '30-45': testarr6[2].count,
                      '45-60': testarr6[3].count,
                      '60-75': testarr6[4].count,
                      '75-90': testarr6[5].count,
                    }"
                  >
                  </area-chart>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab style="border-radius: 0">
          <template v-slot:title>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
                v-if="tabIndex === 2"
            >
              {{ $t("LanguageEn.archive") }}
            </p>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
                v-else
            >
              {{ $t("LanguageEn.archive") }}
            </p>
          </template>
          <div class="">
            <li
                v-if="Object.keys(leaderList).length<1"
                class="list-group-item listHeader"
                style="
                border-radius: 0;
                background: #212225;
                font-size: 12px;
                color: #e6e6e6;
                height: 40px;
              "
            >
              <img style="margin-bottom: 3px" src="@/assets/noInfo.svg"/>{{
                $t("LanguageEn.noInfoa")
              }}
            </li>
            <div v-else>
              <div
                  v-for="(some, i) in leaderList"
                  :key="i"
                  style="
                  border: none;
                  font-size: 12px;
                  background: #141416;
                  list-style-type: none;
                "
                  class=""
              >
                <div style="padding-top: 15px">
                  <li
                      style="
                      font-size: 14px;
                      color: #e6e6e6;
                      background: #212225;
                      padding: 5px;
                      font-weight: bold;
                    "
                  >
                    {{
                      some[0].league.name | transliterate(languageCode)
                    }}
                  </li>
                </div>
                <span v-for="(so, ind) in some" :key="ind" style="">
                  <p
                      style="padding-top: 10px; padding-bottom: 0"
                      v-if="ind == 0"
                  >
                    <span class="badge badge-success" style="font-size: 15px;">{{
                        "Winner" | transliterate(languageCode)
                      }}</span>
                  </p>
                  <span v-if="so.status === 'Winner'">
                    <span
                        style="margin-right: 5px"
                        v-if="so.seasonName != null"
                    >
                      {{ so.seasonName | transliterate(languageCode) }},
                    </span>
                    <span
                        style="
                        padding-top: 5px;
                        padding-bottom: 5px;
                        margin-right: 3px;
                      "
                        v-else
                    >
                      {{ so.season.name | transliterate(languageCode) }},
                    </span>
                  </span>
                </span>
                <span v-for="(so, indx) in some" :key="so.seasonName" style="">
                  <p
                      style="padding-top: 10px; padding-bottom: 0"
                      v-if="indx == 0"
                  >
                    <span class="badge badge-primary" style="font-size: 15px;">
                    {{ "Runner-up" | transliterate(languageCode) }}
                    </span>
                  </p>
                  <span v-if="so.status == 'Runner-up'">
                    <span
                        style="margin-right: 5px"
                        v-if="so.seasonName != null"
                    >
                      {{ so.seasonName | transliterate(languageCode) }},
                    </span>
                    <span
                        style="
                        padding-top: 5px;
                        padding-bottom: 5px;
                        margin-right: 3px;
                      "
                        v-else
                    >
                      {{ so.season.name | transliterate(languageCode) }},
                    </span>
                  </span>
                </span>

                <!-- <div class="">
                  <div class="col mr-0 pr-0" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <img :src="tournamentLogo + some.league.id" alt="" style="width: 24px; margin-right: 3px; background: #E6E6E6; border-radius: 50%; padding: 2px;"> <span class="MobileHide"> {{some.league.name}}</span> <span class="MobileShow"> {{some.league.name.slice(0,14)}} <span v-if="some.league.name.length > 15">.</span></span>
                </div>
                 <div class="col-4" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                  <span>{{some.seasonName}}</span>
                </div>
                <div class="col-3 mr-0" style="color: #E6E6E6; border-bottom: 1px solid #2c2d31;">
                   {{some.status}}
                </div>
            </div> -->
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab style="border-radius: 0">
          <template v-slot:title>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: #e6e6e6;
                font-size: 14px;
                line-height: 25px;
              "
                v-if="tabIndex == 3"
            >
              {{ "Squad" | transliterate(languageCode) }}
            </p>
            <p
                style="
                margin: 0;
                font-weight: 550;
                color: grey;
                font-size: 14px;
                line-height: 25px;
              "
                v-else
            >
              {{ "Squad" | transliterate(languageCode) }}
            </p>
          </template>
          <div class="" style="text-align: left; background: #141416">
            <div>
              <div style="color: whitesmoke">
                <div class="container">
                  <div class="row">
                    <b-form-select
                        v-model="selectedSquadSeason"
                        class="mb-3 col-6"
                        style="
                        margin-top: 15px;
                        background: #212225;
                        border: none;
                        border-radius: 2px;
                        color: #e6e6e6;
                      "
                    >
                      <b-form-select-option
                          v-for="i in seasonList"
                          :key="i.id"
                          :value="i.id"
                      >{{ i.name | transliterate(languageCode) }}
                        {{
                          i.tournament.name | transliterate(languageCode)
                        }}
                      </b-form-select-option
                      >
                    </b-form-select>
                  </div>
                </div>

                <div>
                  <!-- 
            <li class="list-group-item infoItem" v-for="lineup in squad" :key="lineup.id" style="border-radius: 0; border-right: none; background: #141416; border-bottom: 1px solid #2c2d31;">
              <div class="row" style="">
                <div class="col">
                <router-link style="color: white; text-decoration: none;" :to="{ name: 'PlayerPage', params: { id: lineup.player.id} }">
                  <span class="col-1 " style="padding-top: 7px;">{{lineup.squadData.number}}</span>  
                  <span class="col ml-1" style="padding-top: 5px;" v-if="lineup.player.shortName" > <img v-if="lineup.player.country" :src="categoryLogo + lineup.player.country.id" style="width: 18px; border-radius: 2px; margin-right: 5px;" alt=""> {{lineup.player.shortName}}</span> 
                  <span class="col ml-1" style="padding-top: 5px;" v-else> <img v-if="lineup.player.country" :src="categoryLogo + lineup.player.country.id" style="width: 18px; border-radius: 2px; margin-right: 5px;" alt=""> {{lineup.player.commonName}}</span> 
                  <span style="text-align: center;" class="col-1" v-if="lineup.squadData.appearences"> {{lineup.squadData.appearences}} </span> <span style="text-align: center;" class="col-1" v-else>-</span>
                  <span style="text-align: center;" class="col-1" v-if="lineup.squadData.goals"> {{lineup.squadData.goals}} </span> <span style="text-align: center;" class="col-1" v-else>-</span>
                  <span style="text-align: center;" class="col-1" v-if="lineup.squadData.assists"> {{lineup.squadData.assists}} </span> <span style="text-align: center;" class="col-1" v-else>-</span>
                </router-link>
              </div>
              </div>
              </li> -->

                  <div class="container">
                    <div
                        class="row"
                        style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> GK </span>
                      <span class="col pl-1">
                        {{ "Name" | transliterate(languageCode) }}
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/CS.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/spg.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                      v-for="lineup in squad1"
                      :key="lineup.squadData.shortName"
                      style="
                      border-radius: 0;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                            lineup.squadData.number
                                | transliterate(languageCode)
                          }}</span>
                        <span
                            class="col pl-1"
                            style="padding-top: 5px"
                            v-if="lineup.player.shortName"
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.shortName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.commonName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.cleansheets">
                            {{
                              lineup.squadData.cleansheets
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span
                              v-if="
                              lineup.squadData.saves &&
                              lineup.squadData.appearences
                            "
                          >
                            {{
                              (
                                  lineup.squadData.saves /
                                  lineup.squadData.appearences
                              ).toFixed(1) | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div
                        class="row"
                        style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> DF </span>
                      <span class="col pl-1">{{
                          "Name" | transliterate(languageCode)
                        }}</span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/goalBig.png"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Assists.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                      v-for="lineup in squad2"
                      :key="lineup.squadData.shortName"
                      style="
                      border-radius: 0;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                            lineup.squadData.number
                                | transliterate(languageCode)
                          }}</span>
                        <span
                            class="col pl-1"
                            style="padding-top: 5px"
                            v-if="lineup.player.shortName"
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.shortName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.commonName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.goals">
                            {{
                              lineup.squadData.goals
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.assists">
                            {{
                              lineup.squadData.assists
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div
                        class="row"
                        style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> MF </span>
                      <span class="col pl-1">
                        {{ "Name" | transliterate(languageCode) }}
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/goalBig.png"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Assists.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                      v-for="lineup in squad3"
                      :key="lineup.squadData.shortName"
                      style="
                      border-radius: 0;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                            lineup.squadData.number
                                | transliterate(languageCode)
                          }}</span>
                        <span
                            class="col pl-1"
                            style="padding-top: 5px"
                            v-if="lineup.player.shortName"
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.shortName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.commonName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.goals">
                            {{
                              lineup.squadData.goals
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.assists">
                            {{
                              lineup.squadData.assists
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="container">
                    <div
                        class="row"
                        style="
                        color: #e6e6e6;
                        height: 34px;
                        line-height: 34px;
                        background: #212225;
                      "
                    >
                      <span class="col-1 pl-1"> FW </span>
                      <span class="col pl-1">
                        {{ "Name" | transliterate(languageCode) }}
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Appearance.svg"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/goalBig.png"
                        />
                      </span>
                      <span class="col-1">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Assists.svg"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/yellowcardBig.png"
                        />
                      </span>
                      <span class="col-1 MobileHide">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/redCardBig.png"
                        />
                      </span>
                      <span class="col-1 mr-4">
                        <img
                            style="width: 24px; margin-bottom: 4px"
                            src="@/assets/Ratings.svg"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                      v-for="lineup in squad4"
                      :key="lineup.squadData.shortName"
                      style="
                      border-radius: 0;
                      border-right: none;
                      background: #141416;
                      border-bottom: 1px solid #2c2d31;
                    "
                  >
                    <div class="container">
                      <div class="row" style="font-size: 15px; padding: 5px">
                        <span class="col-1 pl-1" style="padding-top: 7px">{{
                            lineup.squadData.number
                                | transliterate(languageCode)
                          }}</span>
                        <span
                            class="col pl-1"
                            style="padding-top: 5px"
                            v-if="lineup.player.shortName"
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.shortName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.shortName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col pl-1" style="padding-top: 5px" v-else
                        ><img
                            v-if="lineup.player.country"
                            :src="categoryLogo + lineup.player.country.id"
                            style="
                              width: 18px;
                              height: 18px;
                              border-radius: 40%;
                              margin-right: 8px;
                            "
                            alt=""
                        />
                          <router-link
                              style="color: white"
                              :to="{
                              name: 'PlayerPage',
                              params: { id: lineup.player.id },
                            }"
                          ><span class="MobileShow">
                              {{
                              lineup.player.commonName.slice(0, 12)
                                  | transliterate(languageCode)
                            }}
                            </span>
                            <span class="MobileHide">
                              {{
                                lineup.player.commonName
                                    | transliterate(languageCode)
                              }}
                            </span></router-link
                          >
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.appearences">
                            {{
                              lineup.squadData.appearences
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.goals">
                            {{
                              lineup.squadData.goals
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1">
                          <span v-if="lineup.squadData.assists">
                            {{
                              lineup.squadData.assists
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.yellowcards">
                            {{
                              lineup.squadData.yellowcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 MobileHide">
                          <span v-if="lineup.squadData.redcards">
                            {{
                              lineup.squadData.redcards
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                        <span class="col-1 mr-3">
                          <span v-if="lineup.squadData.rating">
                            {{
                              lineup.squadData.rating
                                  | transliterate(languageCode)
                            }}
                          </span>
                          <span v-else> - </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {API_BASE_URL} from "@/repository/repository";
import MobileMatchListItem from "@/components/Common/MobileMatchListItem";
import MatchListItem from "@/components/Common/MatchListItem";

export default {
  name: "teamPage",
  data() {
    return {
      gamesHistory: [],
      id: "",
      teamLogo: API_BASE_URL+"/team/logo/",
      categoryLogo: API_BASE_URL+"/category/logo/",
      showDismissibleAlert: false,
      favImage: require("@/assets/favorite1.png"),
      favImage1: require("@/assets/orStar.png"),
      team: null,
      tabIndex: 0,
      teamSeasonStatistics: "",
      teamSeasonStatisticsDetails: "",
      teamSeasonGoalLines: "",
      teamSeasonTimings: "",
      leaderList: {},
      testarr: "",
      testarr2: "",
      testarr3: "",
      testarr4: "",
      testarr5: "",
      testarr6: "",
      groups2: "",
      groups3: "",
      ranking: null,
      ex: "",
      year: "",
      chstat: 1,
      pageCount: 1,
      haw: "home",
      sc: 1,
      seasonList: [],
      selectedSquadSeason: 0,
      squad: [],
      squad1: [],
      squad2: [],
      squad3: [],
      squad4: [],
      pressed: true,
    };
  },

  computed: {
    ...mapGetters(["favTeams", "favMatches", "favTournaments", "isMobile", "isTablet", "portalId", "languageCode", "languageId", "token", "user"]),
  },
  watch: {
    selectedSquadSeason(newVal) {
      this.updateSquad(newVal);
    }
  },
  async mounted() {
    this.id = this.$route.params.id;


    let offset = new Date().getTimezoneOffset();

    fetch(
        API_BASE_URL +
        "/team/matches?langId=" + this.languageId +
        "&portalId=" + this.portalId +
        "&teamId=" + this.id +
        "&timezone=%2B" + offset / -60 + "%3A00" +
        (this.token ? "&token=" + this.token : "")
    ).then(res => res.json())
        .then(data => {

          if (data.code === 200) {
            if (data.ranking.length > 0) {
              this.ranking = data.ranking[0];
            }
            this.gamesHistory = data.matches;
            this.team = data.team;


            this.getStatistics();
            this.getStandings();

            fetch(
                API_BASE_URL + "/team/" + this.id + "/squad/seasons"
            ).then(res => res.json())
                .then(data => {
                  if (data.code === 200) {
                    this.seasonList = data.seasons.reverse();

                    if (this.seasonList.length > 0) {
                      this.selectedSquadSeason = this.seasonList[0].id;
                    }
                  }
                });


          } else {
            alert("Something went wrong " + data.code + ' ' + data.message);
          }

        });
  },

  components: {MatchListItem, MobileMatchListItem},
  props: {},
  methods: {
    ...mapActions(["removeFavorite", "addToFavorites"]),
    async addGames() {
      var offset = new Date().getTimezoneOffset();

      var res = await fetch(
          API_BASE_URL +
          "/team/matches?page=" +
          this.pageCount +
          "&langId=" +
          this.languageId +
          "&portalId=" +
          this.portalId +
          "&teamId=" +
          this.id +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00&token=" +
          this.token
      );
      var data = await res.json();

      var gamesHistory = data.matches;
      this.gamesHistory = this.gamesHistory.concat(gamesHistory);
      this.name = data.team.name;

      this.$forceUpdate();
    },
    getStatistics() {

      fetch(
          API_BASE_URL + "/team/" + this.id + "/statistics?token=" + this.token,
          {
            method: "GET",
            redirect: "follow",
          }
      )
          .then((response) => response.json())
          .then((result) => {
            var path = ["season", "id"]; // by this nested item property array will be grouped

            var groups = result.teamSeasonStatistics.reduce(function (
                    groups,
                    item
                ) {
                  var name = path.reduce(function (data, key) {
                    return data[key];
                  }, item);

                  var group = groups[name] || (groups[name] = []);
                  group.push(item);

                  return groups;
                },
                {});

            const select = Object.keys(groups).map((gid) => {
              const g = groups[gid];
              return {
                id: g[0].season.id,
                y: g[0].season.name,
                name: g[0].season.tournament.name,
              };
            });

            // console.log(select);

            this.testarr = groups;
            this.ex = select.reverse();
            // console.log(Object.values(groups));
            // console.log(result);
            // console.log(groups);
            // console.log(groups[Object.keys(groups)[0]]);
            this.year = this.ex[0].id;

            // for(var key in groups) {
            //   var group = groups[key];
            //   console.log((group));
            // }

            // 2nd section

            var groups1 = result.teamSeasonStatisticsDetails.reduce(function (
                    groups,
                    item
                ) {
                  var name = path.reduce(function (data, key) {
                    return data[key];
                  }, item);

                  var group = groups[name] || (groups[name] = []);
                  group.push(item);

                  return groups;
                },
                {});

            // console.log(groups)
            this.testarr2 = groups1;

            // 3rd section

            var groups2 = result.teamSeasonGoalLines.reduce(function (
                    groups,
                    item
                ) {
                  var name = path.reduce(function (data, key) {
                    return data[key];
                  }, item);

                  var group = groups[name] || (groups[name] = []);
                  group.push(item);

                  return groups;
                },
                {});
            this.groups2 = groups2;

            let groupT = groups2[this.year].reduce((r, a) => {
              r[a.minutes] = [...(r[a.minutes] || []), a];
              return r;
            }, {});

            // console.log(groups2)
            this.testarr3 = groupT;

            // 4th section
            var groups3 = result.teamSeasonTimings.reduce(function (
                    groups,
                    item
                ) {
                  var name = path.reduce(function (data, key) {
                    return data[key];
                  }, item);

                  var group = groups[name] || (groups[name] = []);
                  group.push(item);

                  return groups;
                },
                {});

            this.groups3 = groups3;

            let groupT1 = groups3[this.year].reduce((r, a) => {
              r[a.category] = [...(r[a.category] || []), a];
              return r;
            }, {});

            // console.log(groups2)
            this.testarr4 = groupT1;
            this.testarr5 = this.testarr4["scoring_minutes"];
            this.testarr6 = this.testarr4["goals_conceded_minutes"];
            // console.log(groups)
          })
          .catch((error) => console.log("error", error));
    },
    filter(i) {
      let groupT = this.groups2[i].reduce((r, a) => {
        r[a.minutes] = [...(r[a.minutes] || []), a];
        return r;
      }, {});

      // console.log(groups2)
      this.testarr3 = groupT;

      let groupT1 = this.groups3[i].reduce((r, a) => {
        r[a.category] = [...(r[a.category] || []), a];
        return r;
      }, {});

      // console.log(groups2)
      this.testarr4 = groupT1;
      this.testarr5 = this.testarr4["scoring_minutes"];
      this.testarr6 = this.testarr4["goals_conceded_minutes"];
      // console.log(groups)
      // console.log(this.testarr5)
    },
    // testsm(val){
    //   const keyify = (obj, prefix = '') =>
    //   Object.keys(obj).reduce((res, el) => {
    //     if( Array.isArray(obj[el]) ) {
    //       return res;
    //     } else if( typeof obj[el] === 'object' && obj[el] !== null ) {
    //       return [...res, ...keyify(obj[el], prefix + el + '.')];
    //     }
    //     return [...res, prefix + el];
    //   }, []);

    // const input = val;

    // const output = keyify(input);

    // console.log(output);
    // },
    getStandings() {

      fetch(API_BASE_URL + "/team/" + this.id + "/standings?token=" + this.token,
          {
            method: "GET",
            redirect: "follow",
          }
      )
          .then((response) => response.json())
          .then((result) => {
            // console.log(result.teamTrophies)
            var path = ["league", "name"]; // by this nested item property array will be grouped

            var groups = result.teamTrophies.reduce(function (groups, item) {
              var name = path.reduce(function (data, key) {
                return data[key];
              }, item);

              let  group = groups[name] || (groups[name] = []);
              group.push(item);

              return groups;
            }, {});

            this.leaderList = groups;
          })
          .catch((error) => console.log("error", error));
    },

    updateSquad(val) {
      fetch(
          API_BASE_URL + "/team/" + this.id + "/squad?seasonId=" + val
      ).then(res => res.json())
          .then(data => {

            this.squad = data.seasons;

            this.squad = this.squad.filter((p) => p.squadData.number);

            this.squad1 = this.squad.filter((p) => p.squadData.position_id == 1);
            this.squad1 = this.squad1.sort(function (a, b) {
              const valueA = a.squadData.appearences || 0;
              const valueB = b.squadData.appearences || 0;

              return valueB - valueA;
            });

            this.squad2 = this.squad.filter((p) => p.squadData.position_id == 2);
            this.squad2 = this.squad2.sort(function (a, b) {
              const valueA = a.squadData.appearences || 0;
              const valueB = b.squadData.appearences || 0;

              return valueB - valueA;
            });

            this.squad3 = this.squad.filter((p) => p.squadData.position_id == 3);
            this.squad3 = this.squad3.sort(function (a, b) {
              const valueA = a.squadData.appearences || 0;
              const valueB = b.squadData.appearences || 0;

              return valueB - valueA;
            });

            this.squad4 = this.squad.filter((p) => p.squadData.position_id == 4);
            this.squad4 = this.squad4.sort(function (a, b) {
              const valueA = a.squadData.appearences || 0;
              const valueB = b.squadData.appearences || 0;

              return valueB - valueA;
            });

          });

    },
  },

};
</script>

<style scoped>
.Loc {
  background: #212226;
  width: 100%;
  height: 250px;
  margin-bottom: 10px;
}

.pop {
  animation: color-change 1.2s infinite;
}

@keyframes color-change {
  0% {
    color: #a43d4a;
  }
  50% {
    color: red;
  }
  100% {
    color: #a43d4a;
  }
}

.leagueNam {
  text-align: center;
  padding-top: 70px;
  font-size: 18px;
  color: white;
}

.ybg {
  font-weight: 800;
  background: #be8733 !important;
}

.gcl {
  font-weight: 800;
  color: #419b45 !important;
}

/* Navbar (info, H2H, etc.) */

.navDiv2 {
  width: 100%;
  height: 60px;
  color: white;
  background-image: linear-gradient(#fefefe, #c3c3c3);
}

#topheader2 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#topheader2 .navbar-nav li > a:focus {
  background-image: linear-gradient(#39b44a, #39b54a);
  color: #fff !important;
}

#topheader2 .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}

#routerLink {
  /* padding-top: 10%; */
  display: inline-block;
  text-decoration: none;
  color: #e6e6e6;
  /* margin-top: -8px; */
}

#routerLink .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink .navbar-nav li > a:focus {
  background-image: linear-gradient(#39b44a, #1b5f20);
  color: #fff !important;
}

#routerLink .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}

.listHeader {
  background: #212225;
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
}

.infoItem {
  background: #141416;
  color: white;
  /* height: 60px; */
  border-radius: 0;
  border: none;
}

.circle {
  /* background: #333333; */
  width: 40px;
  height: 40px;
}

.Draw {
  background: #dc2426;
}

#router-link,
#router-link:visited,
#router-link:active,
#router-link:focus {
  text-decoration: none;
  border: 0;
  outline: 0;
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }

  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }

  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>